import axiosInstance from "@/services/AxiosInstance";

type Response = {
  accessToken: string | null;
  refreshToken: string | null;
  status: boolean;
  data: any;
  errors: string[] | null;
  message: string | null;
};

const SignIn = (data: any): Promise<Response> => {
  return axiosInstance({
    method: 'POST',
    url: `/account/sign-in`,
    data,
  });
};
const ForgotPassword = (data: any): Promise<Response> => {
  return axiosInstance({
    method: 'POST',
    url: `/account/forgot-password`,
    data,
  });
};
const ResetPasswordData = (data: any): Promise<Response> => {
  return axiosInstance({
    method: 'POST',
    url: `/account/reset-password`,
    data,
  });
};
const userRegister = (data: any): Promise<Response> => {
  return axiosInstance({
    method: 'POST',
    url: `/account/user/register`,
    data,
  });
};


export { SignIn, ForgotPassword, ResetPasswordData, userRegister };